import { render, staticRenderFns } from "./autoDialog.vue?vue&type=template&id=d27e85c6&scoped=true"
import script from "./autoDialog.vue?vue&type=script&lang=js"
export * from "./autoDialog.vue?vue&type=script&lang=js"
import style0 from "./autoDialog.vue?vue&type=style&index=0&id=d27e85c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27e85c6",
  null
  
)

export default component.exports